import React, { lazy, Suspense } from 'react';
import { OverlayChildProps } from './schema/OverlayChild.types';

const LazyOverlayChild = lazy(
    () => import(/* webpackChunkName: "OverlayChild" */ './components/OverlayChild')
);

export const OverlayChild: React.FC<OverlayChildProps> = React.forwardRef(
    (props: OverlayChildProps) => (
        <Suspense fallback={null}>
            <LazyOverlayChild {...props} />
        </Suspense>
    )
);
